var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91725 6.27733L0.851252 10.988C0.801056 11.0214 0.742739 11.0406 0.682513 11.0434C0.622287 11.0463 0.562407 11.0328 0.509251 11.0044C0.456096 10.9759 0.411654 10.9336 0.380661 10.8818C0.349668 10.8301 0.333283 10.771 0.333252 10.7107V1.28933C0.333283 1.22904 0.349668 1.16988 0.380661 1.11816C0.411654 1.06644 0.456096 1.0241 0.509251 0.995637C0.562407 0.967177 0.622287 0.953669 0.682513 0.95655C0.742739 0.959431 0.801056 0.978594 0.851252 1.012L7.91725 5.72266C7.9629 5.7531 8.00034 5.79434 8.02623 5.84272C8.05211 5.8911 8.06566 5.94513 8.06566 6C8.06566 6.05487 8.05211 6.10889 8.02623 6.15727C8.00034 6.20565 7.9629 6.24689 7.91725 6.27733Z",
    fill: "url(#paint0_linear_920:29)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_920:29",
    x1: 0.333252,
    y1: 3.73027,
    x2: 7.67303,
    y2: 3.79552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DDABD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybtn);
export default __webpack_public_path__ + "static/media/playbtn.c9c00da16995f7d5ff1d1de9e7e30f19.svg";
export { ForwardRef as ReactComponent };